import serves from "@/http";
// import * as storage from "../storage";
import * as types from "./mutations-type";
export const ActionCadastro = ({dispatch},payload)=>{
    return serves.fatura.cadastra(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionLista = ({dispatch},payload)=>{
    return serves.fatura.lista(payload).then(res => {
        dispatch('ActionSetLista',res)
    }).catch(err => {
        dispatch('ActionSetLista',res)
    })
}
export const ActionPesquisa = ({dispatch},payload)=>{
    return serves.fatura.pesquisa(payload).then(res => {
        dispatch('ActionSetPesquisa',res)
    }).catch(err => {
        dispatch('ActionSetPesquisa',res)
    })
}
export const ActionDeletar = ({dispatch},payload)=>{
    return serves.fatura.delete(payload).then(res => {
       
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionEditar = ({dispatch},payload)=>{
    return serves.fatura.editar(payload).then(res => {
        dispatch('ActionSetEditar',res)
    }).catch(err => {
        dispatch('ActionSetEditar',err)
    })
}
export const ActionUpdate = ({dispatch},payload)=>{
    return serves.fatura.update(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionBuscaBoletim = ({dispatch},payload)=>{
    return serves.fatura.buscaboletim(payload).then(res => {
        dispatch('ActionSetBusaBoletim',res)
    }).catch(err => {
        dispatch('ActionSetBusaBoletim',err)
    })
}
export const ActionBuscaTaxas = ({dispatch},payload)=>{
    return serves.fatura.taxas(payload).then(res => {
        dispatch('ActionSetBusaTaxas',res)
    }).catch(err => {
        dispatch('ActionSetBusaTaxas',err)
    })
}
export const ActionCadastroDemostrativo = ({dispatch},payload)=>{
    return serves.fatura.cadastrademostrativo(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionBuscaRublicas = ({dispatch},payload)=>{
    return serves.fatura.rublicas(payload).then(res => {
        dispatch('ActionSetBusaRublicas',res)
    }).catch(err => {
        dispatch('ActionSetBusaRublicas',err)
    })
}
export const ActionCadastroRublicas = ({dispatch},payload)=>{
    return serves.fatura.rublicascadastro(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionBuscaTrabalhadores = ({dispatch},payload)=>{
    return serves.fatura.trabalhadores(payload).then(res => {
        dispatch('ActionSetTrabalhadores',res)
    }).catch(err => {
        dispatch('ActionSetTrabalhadores',err)
    })
}
export const ActionStatusPagamento = ({dispatch},payload)=>{
    return serves.fatura.statuspagamento(payload).then(res => {
        dispatch('ActionSetMsg',res)
    }).catch(err => {
        dispatch('ActionSetMsg',err)
    })
}
export const ActionSetLista = ({commit},payload) =>{
    commit(types.SET_LISTA,payload)
}
export const ActionSetMsg = ({commit},payload) =>{
    commit(types.SET_MSG,payload)
}
export const ActionSetEditar = ({commit},payload) =>{
    commit(types.SET_EDITAR,payload)
}
export const ActionSetPesquisa = ({commit},payload) =>{
    commit(types.SET_PESQUISA,payload)
}
export const ActionSetBusaBoletim = ({commit},payload) =>{
    commit(types.SET_BOLETINS,payload)
}
export const ActionSetBusaTaxas = ({commit},payload) =>{
    commit(types.SET_TAXAS,payload)
}
export const ActionSetBusaRublicas = ({commit},payload) =>{
    commit(types.SET_RUBLICAS,payload)
}
export const ActionSetFaturaId = ({commit},payload) =>{
    commit(types.SET_FATURA_ID,payload)
}
export const ActionSetTrabalhadores = ({commit},payload) =>{
    commit(types.SET_TRABALHADORES,payload)
}
